import type { TableRowData, ColumnConfig } from '../types';
import { isGroupColumn } from '../types';

/**
 * Flattens a column tree into leaf columns only (in render order).
 */
export function getLeafColumns<TRow extends TableRowData>(
  columns: ColumnConfig<TRow>[]
): ColumnConfig<TRow>[] {
  return columns.flatMap(column => {
    if (isGroupColumn(column) && column.children) {
      return getLeafColumns(column.children);
    }
    return [column];
  });
}

/**
 * Returns the number of leaf columns represented by a column.
 */
export function getVisualColumnCountForColumn<TRow extends TableRowData>(
  column: ColumnConfig<TRow>
): number {
  if (isGroupColumn(column) && column.children) {
    return column.children.reduce(
      (count, child) => count + getVisualColumnCountForColumn(child),
      0
    );
  }
  return 1;
}
